import styled from "styled-components";

export const ArticleListContainer = styled.div`
  
    margin-bottom: 5rem;

`

export const ArticleTextContainer = styled.div`
    margin: 2rem 0;
    display: flex;
    div{
      font-size: 1.2rem;
      font-weight: 800;
    }
  
    div:first-of-type{
      font-size : 1.3rem;
      width: 50px;
    }
  
    div:last-of-type{
      width: 81%;
    }
`